export const SE_REGISTRATION_UI_NAV_TREE = {
  label: 'SeRegistrationUi',
  secondaryItems: [
    {
      label: 'Feature Open Registration Search',
      key: 'se-registration-ui-feature-open-registration-search',
      attributes: {
        href: '/docs/se-registration-ui/feature-open-registration-search'
      }
    },
    {
      label: 'Feature Open Registration List',
      key: 'se-registration-ui-feature-open-registration-list',
      attributes: {
        href: '/docs/se-registration-ui/feature-open-registration-list'
      },
    },
    {
      label: 'Feature Completed Registration List',
      key: 'se-registration-ui-feature-completed-registration-list',
      attributes: {
        href: '/docs/se-registration-ui/feature-completed-registration-list'
      },
    },
  ],
}
